import React, { useEffect } from "react";
import SubjectLastScreeningFilter from "../components/subject-details/subject-last-screening-filter/SubjectLastScreeningFilter";
import SubjectHealthReadingContainer from "../components/subject-details/subject-health-reading-details/SubjectHealthReadingContainer";
import Readings from "../components/home/readings/Readings";
import SubjectReadingDetailsGraph from "../components/subjects/subject-details-graph/SubjectReadingDetailsGraph";
import SubjectScreeningHeaderSecondColumn from "../components/subject-details/subject-last-screening-filter/SubjectScreeningHeaderSecondColumn";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  getMyOrganizationRequest,
  getReadingListRequest,
  getReadingRequest,
  getSubjectRequest,
  updateNextScreeningDate,
  updateNextScreeningDateClear,
} from "@src/redux";
import MobileSubjectUserDetails from "../components/subject-details/subject-last-screening-filter/MobileSubjectUserDetails";
import { retrieveItem } from "@src/helpers/functions";

type Props = {};

const SubjectDetails = (props: Props) => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
 
  const { result: updateNextScreeningResult } = useSelector(
    updateNextScreeningDate
  );


  useEffect(() => {
    if (id || updateNextScreeningResult?.status === "success") {
      dispatch(updateNextScreeningDateClear());
      dispatch(getSubjectRequest({ filter: { id: id } }));
      dispatch(getReadingRequest({ filter: { subjectId: id } }));
      dispatch(
        getReadingListRequest({
          filter: { subjectId: id },
          sort: [{ field: "datetime", order: "desc" }],
        })
      );
      dispatch(getMyOrganizationRequest({}));
    }
  }, [id, updateNextScreeningResult]);
  return (
    <div>
      <MobileSubjectUserDetails />
      <SubjectScreeningHeaderSecondColumn className={"mobile"} />
      <SubjectLastScreeningFilter />
      <SubjectHealthReadingContainer />
      <SubjectReadingDetailsGraph />
      <div style={{ marginTop: "10px" }}>
        <Readings />
      </div>
    </div>
  );
};

export default SubjectDetails;
